import type { VoidFunctionComponent, ReactNode } from 'react';
import type { FossaSubscriptionPlan } from '../../../../types';
import { window } from '../../../../globals';
import { getDisplayPlanPrice, getDisplayPlanType, getSubscriptionPlanName, getUsage } from '../utils';
import Flex from '../../../generic/Flex';
import styles from '../style.module.less';
import { BUTTON_SIZE, BUTTON_TYPE, NavigationButton } from '../../../generic';

type PlanInfoProps = {
  data: FossaSubscriptionPlan
};
const PlanInfo: VoidFunctionComponent<PlanInfoProps> = ({
  data,
}) => {
  const currentPlanInfo = [
    {
      title: 'Customer',
      value: window.user?.organization?.title || '',
    },
    {
      title: 'Current Plan',
      value: <DisplayPlanName data={data} />,
    },
    {
      title: 'Plan Price',
      value: getDisplayPlanPrice(data),
    },
    {
      title: 'Plan Type',
      value: getDisplayPlanType(data),
    },
    {
      title: 'Usage',
      value: getUsage(data),
    },
  ];

  return (
    <Flex justify="space-between">
      {currentPlanInfo.map((info) => {
        return (
          <DisplayInfo key={info.title} title={info.title}>
            {info.value}
          </DisplayInfo>
        );
      })}
    </Flex>
  );
};

type DisplayInfoProps = {
  title: string,
  children: ReactNode | string,
};
const DisplayInfo: VoidFunctionComponent<DisplayInfoProps> = ({
  title,
  children,
}) => {
  return (
    <Flex direction="column" align="flex-start">
      <div className={styles.currentPlanInfoLabel}>{title}</div>
      <div className={styles.currentPlanInfoValue}>{children}</div>
    </Flex>
  );
};

const DisplayPlanName: VoidFunctionComponent<PlanInfoProps> = ({
  data,
}) => {
  const name = getSubscriptionPlanName(data);
  const hasCustomBilling = window?.user?.organization?.custom_billing;
  const isOnPrem = window.on_prem;
  const shouldShowLinkToPlans = !hasCustomBilling && !isOnPrem;
  return (
    <Flex gap={8}>
      {name}
      {shouldShowLinkToPlans &&
        <NavigationButton
          to="/account/settings/billing?tab=Plans"
          type={BUTTON_TYPE.OUTLINE}
          size={BUTTON_SIZE.SMALL}
        >
          Change Plan
        </NavigationButton>}
    </Flex>
  );
};

export default PlanInfo;
